import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "../share/form.css";
import { GetProvince, GetCurProvince, GetTitleName } from "../share/api/MasterDataApi";
import { CustomInputNumeric } from "../share/CustomInputNumeric";
import { NumericFormat } from "react-number-format";
import { Loading } from "../share/loading";

export function ProfilePersonalComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const [titleName, setTitleName] = useState([]);
    const [registerationDoc, setRegisterationDoc] = useState(null);

    // master data ที่อยู่ตามทะเบียนบ้าน (AddressType = "0")
    const [locationProvince, setLocationProvince] = useState([]);
    const [locationAmphur, setLocationAmphur] = useState([]);
    const [locationTumbon, setLocationTumbon] = useState([]);

    // master data ที่อยู่ปัจจุบัน (AddressType = "1")
    const [locationCurProvince, setLocationCurProvince] = useState([]);
    const [locationCurAmphur, setLocationCurAmphur] = useState([]);
    const [locationCurTumbon, setLocationCurTumbon] = useState([]);

    useEffect(() => {
        const getProfile = async () => {
            try {
                const res = await fetch("/api/Profile/getProfile", {
                    method: "POST",
                    headers: { 'token': user.token },
                });
                const resJson = await res.json();
                resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
                setProfileData(resJson.dataenum);
            } catch (e) {
                // console.log("err", e)
            }
        };
        getProfile();
    }, []);

    useEffect(() => {
        GetProvince({ setLocationProvince, setLoading });
        GetCurProvince({ setLocationCurProvince, setLoading });
        GetTitleName({ setTitleName, setLoading });
    }, []);

    // ดึง อำเภอ/ตำบล ของที่อยู่เดิมมาแสดงเป็นค่า default
    useEffect(() => {
        if (!profileData) return;
        const preload = async () => {
            if (profileData.address?.provinceCode) {
                await fetchAmphur(profileData.address.provinceCode, setLocationAmphur);
            }
            if (profileData.address?.provinceCode && profileData.address?.amphurCode) {
                await fetchTumbon(profileData.address.provinceCode, profileData.address.amphurCode, setLocationTumbon);
            }
            if (profileData.currentAddress?.provinceCode) {
                await fetchAmphur(profileData.currentAddress.provinceCode, setLocationCurAmphur);
            }
            if (profileData.currentAddress?.provinceCode && profileData.currentAddress?.amphurCode) {
                await fetchTumbon(profileData.currentAddress.provinceCode, profileData.currentAddress.amphurCode, setLocationCurTumbon);
            }
        };
        preload();
    }, [profileData]);

    async function fetchAmphur(provinceCode, setter) {
        try {
            let postData = new FormData();
            postData.append("provinceCode", provinceCode);
            const res = await fetch("/api/MasterData/getAmphur", { method: "POST", body: postData });
            const d = await res.json();
            setter(d.dataenum);
        } catch (e) { /* ignore */ }
    }

    async function fetchTumbon(provinceCode, amphurCode, setter) {
        try {
            let postData = new FormData();
            postData.append("provinceCode", provinceCode);
            postData.append("amphurCode", amphurCode);
            const res = await fetch("/api/MasterData/getTumbon", { method: "POST", body: postData });
            const d = await res.json();
            setter(d.dataenum);
        } catch (e) { /* ignore */ }
    }

    async function fetchLocationId(provinceCode, amphurCode, tumbonCode) {
        try {
            let postData = new FormData();
            postData.append("provinceCode", provinceCode);
            postData.append("amphurCode", amphurCode);
            postData.append("tumbonCode", tumbonCode);
            const res = await fetch("/api/MasterData/getLocationId", { method: "POST", body: postData });
            const d = await res.json();
            return d.dataenum.map(({ locationId }) => locationId).join().toString();
        } catch (e) {
            return "";
        }
    }

    const onSubmit = async (values) => {
        let postData = new FormData();

        const skipKeys = ["address", "currentAddress", "authRegister", "authorizedList", "registerTypeId"];
        Object.entries(values).forEach(([key, value]) => {
            if (skipKeys.includes(key)) return;
            if (value === null || value === undefined) return;
            postData.append(key, value);
        });

        postData.append("authorizedList", JSON.stringify(values.authorizedList ?? []));
        (values.registerTypeId ?? []).forEach(id => postData.append("RegisterTypeId", id));

        // ที่อยู่ตามทะเบียนบ้าน (AddressType = "0")
        if (values.address) {
            postData.append("Address.AddressNo", values.address.addressNo ?? "");
            postData.append("Address.Moo", values.address.moo ?? "");
            postData.append("Address.Soi", values.address.soi ?? "");
            postData.append("Address.Street", values.address.street ?? "");
            postData.append("Address.PostCode", values.address.postCode ?? "");
            postData.append("Address.LocationId", values.address.locationId ?? "");
            postData.append("Address.AddressType", "0");
        }

        // ที่อยู่ปัจจุบัน (AddressType = "1")
        if (values.currentAddress) {
            postData.append("CurrentAddress.AddressNo", values.currentAddress.addressNo ?? "");
            postData.append("CurrentAddress.Moo", values.currentAddress.moo ?? "");
            postData.append("CurrentAddress.Soi", values.currentAddress.soi ?? "");
            postData.append("CurrentAddress.Street", values.currentAddress.street ?? "");
            postData.append("CurrentAddress.PostCode", values.currentAddress.postCode ?? "");
            postData.append("CurrentAddress.LocationId", values.currentAddress.locationId ?? "");
            postData.append("CurrentAddress.AddressType", "1");
        }

        if (registerationDoc) {
            postData.append("registerationDoc", registerationDoc);
        }

        try {
            let res = await fetch("/api/Profile/requestChangeProfile", {
                method: "POST",
                headers: { 'token': user.token },
                body: postData
            });
            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบและยืนยันผ่านทางอีเมล",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload();
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log(e)
        }
    };

    if (!profileData) { return <Loading /> }

    return (
        <Formik
            initialValues={profileData}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {(formik) => {

                const hasType = (id) =>
                    (formik.values?.registerTypeId ?? []).some(t => Number(t) === Number(id));

                const toggleRegisterType = (id) => {
                    const current = (formik.values?.registerTypeId ?? []).map(Number);
                    const next = current.includes(Number(id))
                        ? current.filter(t => t !== Number(id))
                        : [...current, Number(id)];
                    formik.setFieldValue("registerTypeId", next);
                };

                // ====== handler ที่อยู่ (ใช้ร่วมกันทั้ง 2 ที่อยู่) ======
                const handleProvinceChange = async (addrKey, value, setAmphur, setTumbon) => {
                    formik.setFieldValue(`${addrKey}.provinceCode`, value);
                    formik.setFieldValue(`${addrKey}.amphurCode`, "");
                    formik.setFieldValue(`${addrKey}.tumbonCode`, "");
                    setTumbon([]);
                    await fetchAmphur(value, setAmphur);
                };

                const handleAmphurChange = async (addrKey, value, setTumbon) => {
                    formik.setFieldValue(`${addrKey}.amphurCode`, value);
                    formik.setFieldValue(`${addrKey}.tumbonCode`, "");
                    await fetchTumbon(formik.values[addrKey]?.provinceCode, value, setTumbon);
                };

                const handleTumbonChange = async (addrKey, value) => {
                    formik.setFieldValue(`${addrKey}.tumbonCode`, value);
                    const locId = await fetchLocationId(
                        formik.values[addrKey]?.provinceCode,
                        formik.values[addrKey]?.amphurCode,
                        value
                    );
                    formik.setFieldValue(`${addrKey}.locationId`, locId);
                };

                // ====== ตัว render ของ block ที่อยู่ ======
                const renderAddressBlock = (addrKey, provinceList, amphurList, tumbonList, setAmphur, setTumbon) => (
                    <div className="px-4 pt-4">
                        <FormGroup row>
                            <Label sm={2}>เลขที่</Label>
                            <Col sm={4}>
                                <Input
                                    type="text"
                                    className="rounded-pill text-center input-color"
                                    {...formik.getFieldProps(`${addrKey}.addressNo`)}
                                />
                            </Col>
                            <Label sm={2}>หมู่ที่</Label>
                            <Col sm={4}>
                                <Input
                                    type="text"
                                    className="rounded-pill text-center input-color"
                                    {...formik.getFieldProps(`${addrKey}.moo`)}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label sm={2}>ซอย</Label>
                            <Col sm={4}>
                                <Input
                                    type="text"
                                    className="rounded-pill text-center input-color"
                                    {...formik.getFieldProps(`${addrKey}.soi`)}
                                />
                            </Col>
                            <Label sm={2}>ถนน</Label>
                            <Col sm={4}>
                                <Input
                                    type="text"
                                    className="rounded-pill text-center input-color"
                                    {...formik.getFieldProps(`${addrKey}.street`)}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label sm={2}>จังหวัด</Label>
                            <Col sm={4}>
                                <Input
                                    type="select"
                                    className="rounded-pill text-center input-color"
                                    value={formik.values?.[addrKey]?.provinceCode ?? ""}
                                    onChange={(e) => handleProvinceChange(addrKey, e.target.value, setAmphur, setTumbon)}
                                >
                                    <option value="">กรุณาเลือกจังหวัด</option>
                                    {provinceList.map(p => (
                                        <option key={p.provinceCode} value={p.provinceCode}>
                                            {p.provinceName}
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                            <Label sm={2}>อำเภอ/เขต</Label>
                            <Col sm={4}>
                                <Input
                                    type="select"
                                    className="rounded-pill text-center input-color"
                                    value={formik.values?.[addrKey]?.amphurCode ?? ""}
                                    onChange={(e) => handleAmphurChange(addrKey, e.target.value, setTumbon)}
                                >
                                    <option value="">กรุณาเลือกอำเภอ/เขต</option>
                                    {amphurList.map(a => (
                                        <option key={a.amphurCode} value={a.amphurCode}>
                                            {a.amphurName}
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label sm={2}>ตำบล/แขวง</Label>
                            <Col sm={4}>
                                <Input
                                    type="select"
                                    className="rounded-pill text-center input-color"
                                    value={formik.values?.[addrKey]?.tumbonCode ?? ""}
                                    onChange={(e) => handleTumbonChange(addrKey, e.target.value)}
                                >
                                    <option value="">กรุณาเลือกตำบล/แขวง</option>
                                    {tumbonList.map(t => (
                                        <option key={t.tumbonCode} value={t.tumbonCode}>
                                            {t.tumbonName}
                                        </option>
                                    ))}
                                </Input>
                            </Col>
                            <Label sm={2}>รหัสไปรษณีย์</Label>
                            <Col sm={4}>
                                <Input
                                    maxLength={5}
                                    type="text"
                                    className="rounded-pill text-center input-color"
                                    {...formik.getFieldProps(`${addrKey}.postCode`)}
                                />
                            </Col>
                        </FormGroup>
                    </div>
                );

                return (
                    <Container className="d-flex justify-content-center mb-5">
                        <div className="form-border">
                            <Form className="p-5 mb-4" autoComplete="off" onSubmit={formik.handleSubmit}>

                                {/* ประเภทผู้ใช้งาน */}
                                <FormGroup className="mt-3 d-flex justify-content-start">
                                    <Label>ประเภทผู้ใช้งาน</Label>
                                </FormGroup>
                                <div className="ms-5">
                                    <FormGroup>
                                        <Input type="checkbox" className="mx-2 cus-type" checked={hasType(1)} onChange={() => toggleRegisterType(1)} />
                                        <Label>ผู้ประกอบกิจการ</Label>
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="checkbox" className="mx-2 cus-type" checked={hasType(2)} onChange={() => toggleRegisterType(2)} />
                                        <Label>ผู้ดำเนินการฝึก</Label>
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="checkbox" className="mx-2 cus-type" checked={hasType(3)} onChange={() => toggleRegisterType(3)} />
                                        <Label>ผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="checkbox" className="mx-2 cus-type" checked={hasType(4)} onChange={() => toggleRegisterType(4)} />
                                        <Label>กลุ่มผู้ประกอบกิจการ</Label>
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="checkbox" className="mx-2 cus-type" checked={hasType(5)} onChange={() => toggleRegisterType(5)} />
                                        <Label>ศูนย์ประเมินความรู้ความสามารถตามมาตรา 26/4 (2)</Label>
                                    </FormGroup>
                                </div>

                                {/* เลขประจำตัวประชาชน 13 หลัก */}
                                <Row className="pt-2">
                                    <Label>เลขประจำตัวประชาชน (13 หลัก)</Label>
                                    <Col>
                                        <Field name="customerNo">
                                            {({ field, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    allowLeadingZeros
                                                    maxLength={13}
                                                    displayType="number"
                                                    value={values?.customerNo ?? "-"}
                                                    onValueChange={(v) => setFieldValue(field.name, v.value)}
                                                    customInput={CustomInputNumeric}
                                                    disabled
                                                />
                                            )}
                                        </Field>
                                    </Col>
                                </Row>

                                {/* ชื่อ-สกุล */}
                                <FormGroup className="pt-3">
                                    <Label>ชื่อ-สกุล</Label>
                                    <div className="d-flex">
                                        <div className="flex-grow-1">
                                            <Input
                                                type="select"
                                                className="rounded-pill rounded-end text-center input-color"
                                                {...formik.getFieldProps("titleId")}
                                            >
                                                <option value="">คำนำหน้า</option>
                                                {titleName.map(title => (
                                                    <option key={title.titleCode} value={title.titleCode}>
                                                        {title.titleThai}
                                                    </option>
                                                ))}
                                            </Input>
                                        </div>
                                        <div className="w-75">
                                            <Input
                                                type="text"
                                                placeholder="ชื่อ-สกุล"
                                                className="rounded-pill rounded-start text-center input-color"
                                                {...formik.getFieldProps("fullName")}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>

                                {/* เลขที่ใบอนุญาตผู้ดำเนินการทดสอบ (ถ้าเลือกประเภทที่เกี่ยวข้อง) */}
                                {hasType(3) ? (
                                    <FormGroup className="pt-3">
                                        <Label>เลขที่ใบอนุญาตการเป็นผู้ดำเนินการทดสอบมาตรฐานฝีมือแรงงาน</Label>
                                        <Input
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            {...formik.getFieldProps("licenseNo")}
                                        />
                                    </FormGroup>
                                ) : null}

                                {/* ที่อยู่ตามทะเบียนบ้าน */}
                                <div className="pt-3">
                                    <Label>ที่อยู่ตามทะเบียนบ้าน</Label>
                                    {renderAddressBlock("address", locationProvince, locationAmphur, locationTumbon, setLocationAmphur, setLocationTumbon)}
                                </div>

                                {/* ที่อยู่ปัจจุบัน */}
                                <div className="pt-3">
                                    <Label>ที่อยู่ปัจจุบัน (ที่ติดต่อได้)</Label>
                                    {renderAddressBlock("currentAddress", locationCurProvince, locationCurAmphur, locationCurTumbon, setLocationCurAmphur, setLocationCurTumbon)}
                                </div>

                                {/* เบอร์โทร / โทรสาร */}
                                <Row className="pt-3">
                                    <Col>
                                        <Label>โทรศัพท์</Label>
                                        <Input
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            {...formik.getFieldProps("phone")}
                                        />
                                    </Col>
                                    <Col>
                                        <Label>โทรสาร</Label>
                                        <Input
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            {...formik.getFieldProps("fax")}
                                        />
                                    </Col>
                                </Row>

                                {/* อีเมล */}
                                <FormGroup className="pt-3">
                                    <Label>อีเมล</Label>
                                    <Input
                                        type="text"
                                        autoComplete="off"
                                        className="rounded-pill text-center input-color"
                                        {...formik.getFieldProps("email")}
                                    />
                                </FormGroup>

                                {/* ผู้ประสานงาน */}
                                <Row className="pt-3">
                                    <Col>
                                        <Label>ชื่อ-นามสกุลผู้ประสานงาน</Label>
                                        <Input
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            {...formik.getFieldProps("contactorName")}
                                        />
                                    </Col>
                                    <Col>
                                        <Label>หมายเลขโทรศัพท์ผู้ประสานงาน</Label>
                                        <Input
                                            type="text"
                                            className="rounded-pill text-center input-color"
                                            {...formik.getFieldProps("contactorPhone")}
                                        />
                                    </Col>
                                </Row>

                                <div className="text-center p-5">
                                    <button className="submit-btn" type="submit">บันทึก</button>
                                </div>
                            </Form>
                        </div>
                    </Container>
                );
            }}
        </Formik>
    );
}
